import ReactMarkdown from 'react-markdown';
import type { HomeCms } from '@/components/OurPlans/query';
import { Header, StyledReactMarkdown } from './styled';
import { OneColumn } from '@/components/Layout';
import { Row } from '@simplywallst/ui-core';

export const CompareFeatures = ({ title, markdownContent }: HomeCms) => {
  return (
    <Row justifyContent="center">
      <OneColumn>
        <Header>{title}</Header>
        <Row justifyContent="center">
          {markdownContent &&
            markdownContent.map((content, i) => {
              return (
                <StyledReactMarkdown key={i} tableIndex={i}>
                  <ReactMarkdown source={content} escapeHtml={false} />
                </StyledReactMarkdown>
              );
            })}
        </Row>
      </OneColumn>
    </Row>
  );
};
